/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        accordion: {
            color: {
                value: "#282e37",
                type: "color",
            },
            borderBottomColor: {
                value: "#dadada",
                type: "color",
            },
            borderBottomWidth: {
                value: "1px",
                type: "dimension",
            },
            borderBottomStyle: {
                value: "solid",
                type: "strokeStyle",
            },
            borderRadius: {
                value: "0px",
                type: "dimension",
            },
            subtitle: {
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                color: {
                    value: "#6f7377",
                    type: "color",
                },
            },
            summary: {
                minHeight: {
                    value: "40px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "8px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "8px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "8px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "8px",
                    type: "dimension",
                },
                gap: {
                    value: "16px",
                    type: "dimension",
                },
            },
            default: {
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
            },
            hover: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
                backgroundColor: {
                    value: "#f3f3f3",
                    type: "color",
                },
            },
            active: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
            },
            focus: {
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
                boxShadow: {
                    value: {
                        layers: [
                            {
                                inset: true,
                                offsetX: "0px",
                                offsetY: "0px",
                                blur: "0px",
                                spread: "2px",
                                color: "#0b4cce",
                            },
                            {
                                inset: true,
                                offsetX: "0px",
                                offsetY: "0px",
                                blur: "0px",
                                spread: "calc(2px + 1px)",
                                color: "#ffffff",
                            },
                        ],
                        stringValue: "inset 0px 0px 0px 2px #0b4cce, inset 0px 0px 0px calc(2px + 1px) #ffffff",
                    },
                    type: "shadow",
                },
                outlineOffset: {
                    value: "-2px",
                    type: "dimension",
                },
            },
            icon: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
            },
            details: {
                paddingTop: {
                    value: "8px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "8px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "16px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "16px",
                    type: "dimension",
                },
                typography: {
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
